const HUBS = [
  { zone: "WESTERN HUB", cities: "Bhiwandi · JNPT · Sanand" },
  { zone: "NORTHERN CORRIDOR", cities: "NCR · Tauru · Kundli" },
  { zone: "SOUTHERN MATRIX", cities: "Hosur · Sriperumbudur · Shamshabad" },
  { zone: "EASTERN GATEWAY", cities: "Dankuni · Cuttack · Guwahati" },
];

const Coverage = () => (
  <section id="coverage" className="bg-night text-ink py-24 border-b border-line" data-testid="coverage-section">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div>
        <p className="font-mono text-xs uppercase text-brand tracking-widest mb-2">Coverage Map</p>
        <h2 className="font-display text-[clamp(32px,4vw,56px)] uppercase mb-6 tracking-wide">
          Strategic Freight Corridors Across India
        </h2>
        <p className="text-sm text-mute leading-relaxed mb-8">
          Facilitating transparent tenders for prime logistics land, multi-modal
          parks, and automated distribution centers across Tier-1 and Tier-2 hubs.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 font-mono text-xs" data-testid="coverage-hubs">
          {HUBS.map((hub) => (
            <div key={hub.zone} className="p-4 bg-surface border border-line" data-testid={`hub-${hub.zone.toLowerCase().replace(/\s+/g, "-")}`}>
              <span className="text-brand block mb-1">{hub.zone}</span>
              <span className="text-ink">{hub.cities}</span>
            </div>
          ))}
        </div>
      </div>

      <figure className="aspect-[4/3] bg-surface border border-line relative overflow-hidden" data-testid="coverage-map">
        <img
          src="https://images.unsplash.com/photo-1782398138711-72c37bce4b38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxhZXJpYWwlMjBmcmVpZ2h0JTIwdGVybWluYWx8ZW58MHx8fHwxNzkyOTQ2NzgzfDA&ixlib=rb-4.1.0&q=85"
          alt="Aerial view of a freight terminal with shipping containers"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-0 left-0 right-0 flex justify-between items-center font-mono text-xs text-ink bg-night/80 px-6 py-3">
          <span>HUB STATUS: PAN-INDIA</span>
          <span className="text-brand">ONLINE SYNC</span>
        </div>
        <figcaption className="absolute bottom-0 left-0 right-0 text-xs font-mono uppercase tracking-wider text-ink bg-night/80 px-6 py-3">
          Multi-modal warehousing infrastructure corridors
        </figcaption>
      </figure>
    </div>
  </section>
);

export default Coverage;
